import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaCheckCircle } from "react-icons/fa";
import useDocumentMeta from "../hooks/useDocumentMeta";

export default function ThankYou() {
    const navigate = useNavigate();
    const { t } = useTranslation();

    useDocumentMeta({
        title: t("seo.thankYou.title"),
        description: t("seo.thankYou.description"),
        canonicalPath: "/thank-you",
        robots: "noindex,nofollow",
    });

    useEffect(() => {
        // Helpful for GTM / analytics triggers (no PII).
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: "quote_thank_you_view" });
    }, []);

    return (
        <main className="bg-vsblack text-white min-h-[calc(100vh-5rem)] flex items-center justify-center px-6">
            <div className="max-w-5xl w-full">
                <div className="card-dark p-8 md:p-12">
                    <motion.div
                        initial={{ scale: 0.8, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        transition={{ duration: 0.3 }}
                        className="text-center py-12"
                    >
                        <motion.div
                            initial={{ scale: 0 }}
                            animate={{ scale: 1 }}
                            transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
                            className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-emerald-500 to-emerald-700 rounded-full flex items-center justify-center shadow-lg"
                        >
                            <FaCheckCircle className="text-4xl text-white" />
                        </motion.div>
                        <h1 className="text-3xl font-bold text-white mb-4 font-serif">
                            {t("form.success.title")}
                        </h1>
                        <p className="text-gray-400 text-lg mb-2">{t("form.success.message")}</p>
                        <p className="text-gray-500">{t("form.success.description")}</p>

                        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
                            <button className="btn-primary" onClick={() => navigate("/")}>
                                {t("thankYou.backHome")}
                            </button>
                            <button
                                className="px-6 py-3 rounded-lg border-2 border-vsred text-vsred-light font-semibold hover:bg-vsred hover:text-white transition-all duration-300"
                                onClick={() => navigate("/products")}
                            >
                                {t("thankYou.viewProducts")}
                            </button>
                        </div>
                    </motion.div>
                </div>
            </div>
        </main>
    );
}
